<!-- 🔴 ALL ORIGINAL STRUCTURE COMMENTED OUT LINE BY LINE (SuperPrompt V7) -->
<!-- <style>
  #cont { font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif;  text-align: center;}


    .flex-wrapper {
        display: flex;
        flex-flow: row nowrap;
    }

    .single-chart {
        width: 100%;
        justify-content: space-around ;
    }

    .circular-chart {
        display: block;
        margin: 10px auto;
        max-width: 80%;
        max-height: 250px;
    }

    .circle-bg {
        fill: none;
        stroke: #ff0606;
        stroke-width: .6;
    }

    .circle {
        fill: none;
        stroke-width: 2.0;
        stroke-linecap: square;
        animation: progress 1s ease-out forwards;
    }

    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }

    .circular-chart.orange .circle {
        stroke: #ff9f00;
    }

    .circular-chart.green .circle {
        stroke: #4cb050;
    }

    .circular-chart.blue .circle {
        stroke: #3c9ee5;
    }

    .percentage {
        fill: #666;
        font-family: sans-serif;
        font-size: 0.5em;
        text-anchor: middle;
    }

    .details p{
        margin:3px 0px 0px 0px;

    }

.custom-select.xlarge {
	width: 380px;
}



   .wf-dashboard{
     padding:10px 20px
     }

    .wf-dashboard ul {
         margin: 0px;
         padding: 0px;
     }

.wf-dashboard .panel{
margin: 0px;
}


        .wf-dashboard .panel-body ul li {
          list-style: none;
          margin-top: 5px;
          margin-bottom: 5px;
          padding:3px;
          padding-left:10px;
          -moz-border-radius-topleft: 5px;
          -moz-border-radius-bottomleft: 5px;
          border-top-left-radius: 5px;
           border-bottom-left-radius: 5px;
           border:1px solid #0d0d0d;
           cursor:pointer;
           font-size:15px;
          }


         .wf-dashboard .panel-body ul li:hover {
            background-color: #1ca5cf;
            color:white ;

           }


        .wf-dashboard .panel-body ul li:hover.setChecked {
            background-color: #e5e4e4;
             color:black ;


           }

    .red-text{
    color:red;
    }
     .col-md-6 {
    width: 100%;
  }
   .font-weight{
   		font-weight: bold;
   	
   }
    .app-header{
        background-color:white;
        height:27px;
        width:100%;
        border-bottom:1px solid #000;
        margin:0px;
        overflow: auto;
    }

    .app-header h1{
        padding:0px;
        margin:4px;
        font-size:18px;
    }

  .app-nav{
      background-color:#c4c3c3;
      border-bottom:1px solid #000;
  }


    .app-nav  ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
        background-color: #333;
    }

    .app-nav li {
        float: left;
    }

    .app-nav  li a {
        display: block;
        color: white;
        text-align: center;
        padding: 6px 10px;
        text-decoration: none;
        height:33px;
    }

    /* Change the link color to #111 (black) on hover */
    .app-nav li a:hover {
        background-color: #4CAF50;
        text-decoration: none;
        color:#fff;
    }

    .app-nav li .active {
        background-color: #4CAF50;
        text-decoration: none;
        color:#fff;
    }


    .app-body{
        padding:0px;
        background-color:#FFFFFF;
    }

    .separator{
        width:10px;
        background-color: #4c4f4f;
        display: block;
        color: white;
        text-align: center;
        padding: 6px 10px;
        text-decoration: none;
    }



    .entitiy{
       background-color: #5d5f5f;
        margin-left:1px;
        cursor:pointer;
        font-size:12px;
        height:33px
    }

    .entitiy a{
        padding: 10px 10px !important;


    }


    .entitiy i{
        margin-left:5px;
    }
    
    
    multiselect {
	display: block;
	border: 1px solid lightgrey;
	border-radius:4px;
}

multiselect .btn {
	width: 100%;
	background-color: #FFF;
}
multiselect .btn[disabled] {
    width: 100%;
    background-color: #eee;
}
multiselect .btn.error {
	border: 1px solid #da4f49 !important;
}

multiselect .dropdown-menu {
	max-height: 300px;
	overflow-y: auto;
}

multiselect .dropdown-menu {
	width: 100%;
	box-sizing: border-box;
	padding: 2px;
}

multiselect .dropdown-menu>li>a {
	padding: 3px 10px;
	cursor: pointer;
}


table {
	border-collapse: collapse;
  	border: 1px solid #ddd;
	padding: 4px;
	position: sticky;
    top: 0;
    z-index: 10;
}

th {
 border: 1px solid white;
 padding: 4px;
 }

/* thead tr:first-child th { position: sticky; top: 0; } */
/* thead tr:second-child th { position: sticky; top: 0; } */

td {
 border: 1px solid #ddd;
 padding: 4px;
}



</style> -->

<!-- <div class="modal-header">
	<h3 class="modal-title">
		Special Allocation<i ng-click="ctrl.cancel()"
			class="fa fa-times pull-right"></i>
        <i class="fa pull-right" ng-class="{'fa-plus-square-o': ctrl.minimise, 'fa-minus-square-o': !ctrl.minimise}" style= "margin-right: 10px" ng-click="ctrl.minimise=!ctrl.minimise"></i>
    </h3>
</div> -->

<!-- <form name="ctrl.screenFrom" id="screenFrom" uib-collapse="ctrl.minimise" disabled="disabled" class="form-horizontal" novalidate>
	<div class="modal-body no-body-scroll">
		<div class="divShadow1">

			<div  class="table table-hover table-bordered table-striped table-condensed">
					<table style=" border: 1px solid #ddd; border-collapse: collapse; padding: 4px;">
						<thead style="white-space:nowrap;">
							<tr>
								<th colspan="10" style="width: 4%;text-align: center;">Partnership Details</th>
							</tr>
							<tr>
								<th rowspan="2" style="width: 4%;">LEID</th>
								<th rowspan="2" style="width: 4%;">Tax Code</th>
								<th rowspan="2" style="width: 4%;">Reporting Period</th>
								<th rowspan="2" style="width: 4%;">ME Code</th>
								<th rowspan="2" style="width: 4%;">Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr style=" border: 1px solid #ddd;padding: 4px;">
								<td>{{ctrl.pshipLeid}}</td>
								<td>{{ctrl.pshipCdrNo}}</td>
								<td>{{ctrl.pshipReportingPeriod}}</td>
								<td>{{ctrl.pshipMeCode}}</td>
								<td data-ng-class="{'color-red' : ctrl.pshipAmount < 0 }">{{ctrl.pshipAmount}}</td>
							</tr>
						</tbody>
					</table>
				</div>	
			
				<div class="table table-hover table-bordered table-striped table-condensed" style="min-height:100px; max-height: 350px; overflow-y: auto;overflow-x: scroll;">
					<table style=" border: 1px solid #ddd; border-collapse: collapse; padding: 4px;">
						<thead style="white-space:nowrap;">
							<tr>
								  <th colspan="5" style="border-right: 1px solid black;text-align: center;">Partner Details</th>
							      <th colspan="2" style="border-right: 1px solid black;text-align: center;">Actual Allocation</th>
							      <th colspan="2" style="text-align: center;border-right: 1px solid black;">Special Allocation</th>
							      <th colspan="2" style="text-align: center; ">Edit - Special Allocation</th>
							   </tr>
	                           
							<tr>
							    <th rowspan="2" style="width: 4%;">Source System</th>
								<th rowspan="2" style="width: 4%;">LEID</th>
								<th rowspan="2" style="width: 4%;">Tax Code</th>
								<th rowspan="2" style="width: 4%;">Reporting Period</th>
								<th rowspan="2" style="width: 4%;">ME Code</th>
								<th rowspan="2" style="width: 4%;">Ratio</th>
								<th rowspan="2" style="width: 4%;">Amount</th>
								<th rowspan="2" style="width: 4%;">Ratio</th>
								<th rowspan="2" style="width: 4%;">Amount</th>
								<th rowspan="2" style="width: 4%;">Ratio</th>
								<th rowspan="2" style="width: 4%;">Amount</th>
						</tr>
						</thead>
						<tbody>
							<tr ng-repeat="t in ctrl.partnerDetailsData" style=" border: 1px solid #ddd;padding: 2px;">
								<td>{{ t.PTR_SOURCE_FLAG }}</td>
								<td>{{ t.PTR_LEID }}</td>
								<td>{{ t.PTR_CDR_NO }}</td>
								<td>{{ t.PTR_REPORTING_PERIOD }}</td>
								<td>{{ t.PTR_ME_CODE }}</td>
								<td>{{ t.PTR_ACTUAL_RATIO }}</td>
								<td data-ng-class="{'color-red' :  t.PTR_ACTUAL_AMOUNT < 0 }">{{ t.PTR_ACTUAL_AMOUNT }}</td>
								<td>{{ t.PTR_SPECIAL_ALLOCATION_RATIO }}</td>
								<td data-ng-class="{'color-red' :  t.PTR_SPECIAL_ALLOCATION_AMOUNT < 0 }">{{ t.PTR_SPECIAL_ALLOCATION_AMOUNT }}</td>
								
								<td><input id="{{'FTC_PP_UD_1' + $index}}" type="number" class="form-control" style="width: 150px"  min="0" max="1"  value="{{t.NEW_ALLOCATION_RATIO}}" 
									 	   ng-model="t.NEW_ALLOCATION_RATIO" ng-change="ctrl.updateAllocationAmount(t)"> </td>
								<td data-ng-class="{'color-red' :  t.NEW_ALLOCATION_AMOUNT < 0 }">{{t.NEW_ALLOCATION_AMOUNT}}</td>
								
							</tr>
							<tr>
								<td></td><td></td><td></td><td></td>
								<td style="font-weight: bold;">Total</td>
								<td>{{ctrl.ptr_actual_ratio}}</td>
								<td data-ng-class="{'color-red' :  ctrl.ptr_actual_amount < 0 }">{{ctrl.ptr_actual_amount}}</td>
								<td>{{ctrl.ptr_special_actual_ratio}}</td>
								<td data-ng-class="{'color-red' :  ctrl.ptr_special_actual_amount < 0 }">{{ctrl.ptr_special_actual_amount}}</td>
								<td>{{ctrl.total_allocation_ratio}}</td>
								<td data-ng-class="{'color-red' :  ctrl.total_allocation_amount < 0 }">{{ctrl.total_allocation_amount}}</td>
							</tr>
						</tbody>
					</table>
				</div>	
			</div>
		</div>
</form>	 -->

<!-- <div class="modal-footer" uib-collapse="ctrl.minimise">
	<button id="FTC_PP_UD_2" class="btn  btn-info btn-sm" type="button"	ng-click="ctrl.save()" ng-disabled="ctrl.isSaveClicked"> Save </button>
	<button id="FTC_PP_UD_3" class="btn btn-danger-outline btn-sm" type="button" ng-click="ctrl.reset()">Reset</button>
	<button id="FTC_PP_UD_4" class="btn btn-warning btn-sm" type="button" ng-click="ctrl.cancel()">Cancel</button>
</div> -->

<!-- DOKŁADNE ODWZOROWANIE ORYGINALNEGO HTML -->

<!-- Modal Header z ikonami dokładnie jak w oryginale -->
<div class="modal-header">
	<h3 class="modal-title">Special Allocation</h3>
	<div class="header-actions">
		<i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
		<i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
	</div>
</div>

<form name="screenFrom" id="screenFrom" [hidden]="minimise" class="form-horizontal" novalidate>
	<div class="modal-body no-body-scroll">
		<div class="divShadow1">

			<!-- Pierwsza tabela - Partnership Details z danymi -->
			<div class="table table-hover table-bordered table-striped table-condensed">
				<table style="border: 1px solid #ddd; border-collapse: collapse; padding: 4px;">
					<thead style="white-space:nowrap;">
						<!-- Normal mode header -->
						@if (mode === 'normal') {
<tr>
							<th colspan="5" style="width: 4%;text-align: center;">Partnership Details</th>
						</tr>
}
						<!-- BEAT mode header -->
						@if (mode === 'beat') {
<tr>
							<th colspan="6" style="width: 4%;text-align: center;">Partnership Details</th>
						</tr>
}
						
						<!-- Normal mode columns -->
						@if (mode === 'normal') {
<tr>
							<th style="width: 4%;">LEID</th>
							<th style="width: 4%;">Tax Code</th>
							<th style="width: 4%;">Reporting Period</th>
							<th style="width: 4%;">ME Code</th>
							<th style="width: 4%;">Amount</th>
						</tr>
}
						<!-- BEAT mode columns -->
						@if (mode === 'beat') {
<tr>
							<th style="width: 4%;">LEID</th>
							<th style="width: 4%;">Tax Code</th>
							<th style="width: 4%;">Reporting Period</th>
							<th style="width: 4%;">ME Code</th>
							<th style="width: 4%;">Payment Amount</th>
							<th style="width: 4%;">Benefit Amount</th>
						</tr>
}
					</thead>
					<tbody>
						<!-- Normal mode data -->
						@if (mode === 'normal') {
<tr style="border: 1px solid #ddd;padding: 4px;">
							<td>{{pshipLeid}}</td>
							<td>{{pshipCdrNo}}</td>
							<td>{{pshipReportingPeriod}}</td>
							<td>{{pshipMeCode}}</td>
							<td [ngClass]="{'color-red': pshipAmount < 0}">{{pshipAmount}}</td>
						</tr>
}
						<!-- BEAT mode data -->
						@if (mode === 'beat') {
<tr style="border: 1px solid #ddd;padding: 4px;">
							<td>{{pshipLeid}}</td>
							<td>{{pshipCdrNo}}</td>
							<td>{{pshipReportingPeriod}}</td>
							<td>{{pshipMeCode}}</td>
							<td [ngClass]="{'color-red': pshipBeatPaymentAmount < 0}">{{pshipBeatPaymentAmount}}</td>
							<td [ngClass]="{'color-red': pshipBeatBenefitAmount < 0}">{{pshipBeatBenefitAmount}}</td>
						</tr>
}
					</tbody>
				</table>
			</div>	
		
			<!-- Druga tabela - Partner Details z scroll -->
			<div class="table table-hover table-bordered table-striped table-condensed" style="min-height:100px; max-height: 350px; overflow-y: auto;overflow-x: scroll;">
				<table style="border: 1px solid #ddd; border-collapse: collapse; padding: 4px;">
					<thead style="white-space:nowrap;">
						<!-- Normal mode header -->
						@if (mode === 'normal') {
<tr>
							<th colspan="5" style="border-right: 1px solid black;text-align: center;">Partner Details</th>
							<th [attr.colspan]="showAmounts ? 2 : 1" style="border-right: 1px solid black;text-align: center;">Actual Allocation</th>
							<th [attr.colspan]="showAmounts ? 2 : 1" style="text-align: center;border-right: 1px solid black;">Special Allocation</th>
							<th [attr.colspan]="showAmounts ? 2 : 1" style="text-align: center;">Edit - Special Allocation</th>
						</tr>
}
						
						<!-- BEAT mode header -->
						@if (mode === 'beat') {
<tr>
							<th colspan="5" style="border-right: 1px solid black;text-align: center;">Partner Details</th>
							<th colspan="4" style="border-right: 1px solid black;text-align: center;">Actual Allocation</th>
							<th colspan="4" style="text-align: center;border-right: 1px solid black;">Special Allocation</th>
							<th colspan="4" style="text-align: center;">Edit - Special Allocation</th>
						</tr>
}
                           
						<!-- Normal mode columns -->
						@if (mode === 'normal') {
<tr>
							<th style="width: 4%;">Source System</th>
							<th style="width: 4%;">LEID</th>
							<th style="width: 4%;">Tax Code</th>
							<th style="width: 4%;">Reporting Period</th>
							<th style="width: 4%;">ME Code</th>
							<th style="width: 4%;">Ratio</th>
							@if (showAmounts) {
<th style="width: 4%;">Amount</th>
}
							<th style="width: 4%;">{{ showAmounts ? 'Ratio' : 'Prev Ratio' }}</th>
							@if (showAmounts) {
<th style="width: 4%;">Amount</th>
}
							<th style="width: 4%;">{{ showAmounts ? 'Ratio' : 'New Ratio' }}</th>
							@if (showAmounts) {
<th style="width: 4%;">Amount</th>
}
						</tr>
}
						
						<!-- BEAT mode columns -->
						@if (mode === 'beat') {
<tr>
							<th style="width: 4%;">Source System</th>
							<th style="width: 4%;">LEID</th>
							<th style="width: 4%;">Tax Code</th>
							<th style="width: 4%;">Reporting Period</th>
							<th style="width: 4%;">ME Code</th>
							<th style="width: 4%;">Ratio</th>
							<th style="width: 4%;">Payment Amount</th>
							<th style="width: 4%;">Benefit Amount</th>
							<th style="width: 4%;">Ratio</th>
							<th style="width: 4%;">Payment Amount</th>
							<th style="width: 4%;">Benefit Amount</th>
							<th style="width: 4%;">Ratio</th>
							<th style="width: 4%;">Payment Amount</th>
							<th style="width: 4%;">Benefit Amount</th>
						</tr>
}
					</thead>
					<tbody>
						<!-- Normal mode data rows -->
						@if (mode === 'normal') {

							@for (t of partnerDetailsData; track $index; let i = $index) {
<tr style="border: 1px solid #ddd;padding: 2px;">
								<td>{{ t.PTR_SOURCE_FLAG }}</td>
								<td>{{ t.PTR_LEID }}</td>
								<td>{{ t.PTR_CDR_NO }}</td>
								<td>{{ t.PTR_REPORTING_PERIOD }}</td>
								<td>{{ t.PTR_ME_CODE }}</td>
								<td>{{ t.PTR_ACTUAL_RATIO }}</td>
								@if (showAmounts) {
<td [ngClass]="{'color-red': t.PTR_ACTUAL_AMOUNT < 0}">{{ t.PTR_ACTUAL_AMOUNT }}</td>
}
								<td>{{ t.PTR_SPECIAL_ALLOCATION_RATIO }}</td>
								@if (showAmounts) {
<td [ngClass]="{'color-red': t.PTR_SPECIAL_ALLOCATION_AMOUNT < 0}">{{ t.PTR_SPECIAL_ALLOCATION_AMOUNT }}</td>
}
								
							<td><input [id]="'FTC_PP_UD_1' + i" type="number" class="form-control" style="width: 150px" min="0" max="1" 
								[(ngModel)]="t.NEW_ALLOCATION_RATIO" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateAllocationAmount(t)"> </td>
							@if (showAmounts) {
<td [ngClass]="{'color-red': t.NEW_ALLOCATION_AMOUNT < 0}">{{t.NEW_ALLOCATION_AMOUNT}}</td>
}
							</tr>
}
						
}
						
						<!-- BEAT mode data rows -->
						@if (mode === 'beat') {

							@for (t of partnerDetailsData; track $index; let i = $index) {
<tr style="border: 1px solid #ddd;padding: 2px;">
								<td>{{ t.PTR_SOURCE_FLAG }}</td>
								<td>{{ t.PTR_LEID }}</td>
								<td>{{ t.PTR_CDR_NO }}</td>
								<td>{{ t.PTR_REPORTING_PERIOD }}</td>
								<td>{{ t.PTR_ME_CODE }}</td>
								<td>{{ t.PTR_ACTUAL_RATIO }}</td>
								<td [ngClass]="{'color-red': t.PTR_ACTUAL_BEAT_PAYMENT < 0}">{{ t.PTR_ACTUAL_BEAT_PAYMENT }}</td>
								<td [ngClass]="{'color-red': t.PTR_ACTUAL_BEAT_BENEFIT < 0}">{{ t.PTR_ACTUAL_BEAT_BENEFIT }}</td>
								<td>{{ t.PTR_SPECIAL_ALLOCATION_RATIO }}</td>
								<td [ngClass]="{'color-red': t.PTR_SPECIAL_ACTUAL_BEAT_PAYMENT < 0}">{{ t.PTR_SPECIAL_ACTUAL_BEAT_PAYMENT }}</td>
								<td [ngClass]="{'color-red': t.PTR_SPECIAL_ACTUAL_BEAT_BENEFIT < 0}">{{ t.PTR_SPECIAL_ACTUAL_BEAT_BENEFIT }}</td>
								
							<td><input [id]="'FTC_PP_UD_1' + i" type="number" class="form-control" style="width: 150px" min="0" max="1" 
								[(ngModel)]="t.NEW_ALLOCATION_RATIO" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateAllocationAmount(t)"> </td>
							<td [ngClass]="{'color-red': t.NEW_ALLOCATION_BEAT_PAYMENT < 0}">{{t.NEW_ALLOCATION_BEAT_PAYMENT}}</td>
								<td [ngClass]="{'color-red': t.NEW_ALLOCATION_BEAT_BENEFIT < 0}">{{t.NEW_ALLOCATION_BEAT_BENEFIT}}</td>
							</tr>
}
						
}
						
						<!-- Normal mode total row -->
						@if (mode === 'normal') {
<tr>
							<td></td><td></td><td></td><td></td>
							<td style="font-weight: bold;">Total</td>
							<td>{{ptr_actual_ratio}}</td>
							@if (showAmounts) {
<td [ngClass]="{'color-red': ptr_actual_amount < 0}">{{ptr_actual_amount}}</td>
}
							<td>{{ptr_special_actual_ratio}}</td>
							@if (showAmounts) {
<td [ngClass]="{'color-red': ptr_special_actual_amount < 0}">{{ptr_special_actual_amount}}</td>
}
							<td>{{total_allocation_ratio}}</td>
							@if (showAmounts) {
<td [ngClass]="{'color-red': total_allocation_amount < 0}">{{total_allocation_amount}}</td>
}
						</tr>
}
						
						<!-- BEAT mode total row -->
						@if (mode === 'beat') {
<tr>
							<td></td><td></td><td></td><td></td>
							<td style="font-weight: bold;">Total</td>
							<td>{{ptr_actual_ratio}}</td>
							<td [ngClass]="{'color-red': ptr_actual_beat_payment < 0}">{{ptr_actual_beat_payment}}</td>
							<td [ngClass]="{'color-red': ptr_actual_beat_benefit < 0}">{{ptr_actual_beat_benefit}}</td>
							<td>{{ptr_special_actual_ratio}}</td>
							<td [ngClass]="{'color-red': ptr_special_actual_beat_payment < 0}">{{ptr_special_actual_beat_payment}}</td>
							<td [ngClass]="{'color-red': ptr_special_actual_beat_benefit < 0}">{{ptr_special_actual_beat_benefit}}</td>
							<td>{{total_allocation_ratio}}</td>
							<td [ngClass]="{'color-red': total_allocation_beat_payment < 0}">{{total_allocation_beat_payment}}</td>
							<td [ngClass]="{'color-red': total_allocation_beat_benefit < 0}">{{total_allocation_beat_benefit}}</td>
						</tr>
}
					</tbody>
				</table>
			</div>	
		</div>
	</div>
</form>	

<div class="modal-footer" [hidden]="minimise">
	<button id="FTC_PP_UD_2" class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
		@if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
	</button>
	<button id="FTC_PP_UD_3" class="reset-button" type="button" (click)="reset()">Reset</button>
	<button id="FTC_PP_UD_4" class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>